import React,{Component} from 'react';
import PropTypes from 'prop-types';

import CheckSVG from '../../../shared/assets/check.svg';

class OnboardingStepIndicator extends Component {
  render(){
    const { number, name, active, completed } = this.props;

    return (
      <div className='progress-step'>
        {completed ? (
          <span>
            <img 
              className='progress-step-check' 
              src={CheckSVG} 
              alt='Check mark'
            />
            &nbsp;</span>
        ) : (
          <div className={`progress-step-number ${active ? 'active':''}`}>
            {number}
          </div>
        )}
        {name}
      </div>
    )
  }
}

OnboardingStepIndicator.propTypes = {
  number:PropTypes.number.isRequired,
  name:PropTypes.string.isRequired,
  active:PropTypes.bool,
  completed:PropTypes.bool
};

OnboardingStepIndicator.defaultProps = {
  active:false,
  completed:false
};

export default OnboardingStepIndicator;


// WEBPACK FOOTER //
// ./src/routes/OnboardingPortal/components/OnboardingStepIndicator.js